import { LayoutConfig } from "./sampleConfig";
import { Section } from "./components/sections/TextSection";

export enum ScreenMeasuringUnit{
  cm = 1,
  inch = 2,
  pixel = 3
}

export type Layer = {
  name: string;
  rows: number;
  cols: number;
  containers: Section[];
};


export interface ILayer {
  name: string;
  rows: number;
  cols: number;
  containers: Section[];
}

export interface ILayoutConfig {
  rowCount: number;
  colCount: number;
  layers: ILayer;
}

export interface IMediaDeliveryConfig {
  getURLFromFile(file: File): Promise<string>;
}
export interface IScreenSize{
  label:string;
  width:number;
  height:number;
  unit:ScreenMeasuringUnit
}
export interface ILayoutBuilderOptions {
  mediaDeliveryService: IMediaDeliveryConfig;
  layoutConfig: LayoutConfig;
  screenSizes:IScreenSize[]
}
